/** section: Whitespace
* class StoryBoard
*
* The StoryBoard class can be used for altering the numeric css properties of
* elements through a predetermined range based on the scrolled position of
* defined blocks.
*
* This creates the effect of content appearing, loading or blending in as the
* visitor scrolls through the document. Works best with longer documents that
* have room to scroll.
**/
(function($, win, ob_set) {
	var WSStoryBoard = function(block_selector, timeline, options) {
		/**
		* new StoryBoard(blocks, timeline[, options])
		* - blocks (String): A CSS selector defining the container blocks.
		* - timeline (Object): The animation timeline (see below).
		* - options (Object): Initialisation options
		*
		* Creates a new StoryBoard instance.
		*
		* #### Timeline
		* The `timeline` Object contains multiple Objects whos key represents the ID of the
		* elements to which it refers. An example structure is as follows:
		*
		*     timeline = {
		*       'block-1': {
		*           'tween': Effect.Transitions.sinoidal,
		*           'duration': 500,
		*           'nodes': [{
		*               'selector': 'div.product-lineup>div.product:nth-child(1)',
		*               'delay': 310,
		*               'properties': {
		*                   'top': [-580, 0]
		*               }
		*           },{
		*               'selector': 'div.product-lineup>div.product:nth-child(2)',
		*               'delay': 290,
		*               'properties': {
		*                   'top': [-580, 0]
		*               }
		*           }]
		*       },
		*       'block-2': {
		*           'stick': true,
		*           'tween': Effect.Transitions.Cubic.easeInOut,
		*           'delay': 450,
		*           'duration': 500,
		*           'nodes': [{
		*               'selector': 'ul.carousel>li.slide-group li.slide:nth-child(1)',
		*               'properties': {
		*                   'top': [300, 0],
		*                   'opacity': [0.2, 1]
		*               }
		*           }]
		*       }
		*     };
		*
		* The complete structure of each __block__ definition is as follows:
		*
		* * [`key`]: ID of the element containing the selector nodes.
		*     * `stick` (`Boolean`; default false): If `false`, the animation will remain active after
		*       completed.
		*     * `tween` (`Function`): The Scriptaculous tweening function for all nodes within this block.
		*     * `delay` (`Number`; default `0`): The delay in pixels before the animation starts.
		*     * `duration` (`Number`): The duration for the animation in pixels. Capped to the block's
		*       height.
		*     * `nodes` (`Object`): Individual node options.
		*
		* Individual __node__ array objects are structured as follows:
		*
		* * `selector`: (`String`): The CSS selector for this node. The selector should result in a
		*   single DOM element.
		* * `delay` (`Number`; default `inherit`): Overrides the `delay` for the block.
		* * `duration` (`Number`; default `inherit`): Overrides the `duration` for the block.
		*   `properties`: (`Object`): A key/values pair of CSS properties and their start/end values.
		*   * `property`: Each property value should be a key defining the CSS property to set, and a
		*     value of an array defining the start and end values. If the end value is omitted, it
		*     defaults to the original value set by the CSS.
		*
		* #### Initialisation options
		* The following options can be set when initialising:
		*
		* * `debug` (`Boolean`; default `false`): Enables debug mode.
		* * `offset` (`Number`; default `0`): Set the global offset of the entire storyboard in pixels.
		**/
		var cls, my;

		cls = {
			/**
			* StoryBoard#update([full]) -> undefined
			* - full (Boolean): Perform a full update (which will include recalculating
			* block sizes)
			*
			* Updates the internally stored metrics for each managed block.
			* This can be used when the blocks change size for any reason.
			*
			* This method is executed internally when the viewport is resized.
			**/
			update: function() {
				return my.update.apply(this, arguments);
			}
		};

		my = {
			enable: function() {
				options = ob_set(options || {}, {
					'debug': false,
					'offset': 0
				});

				my.regex = {
					'raw_number': new RegExp("[^\\d-]", "g")
				};

				my.status = {
					'active': false,
					'stuck': 0
				};

				if ($(block_selector).length) {
					my.elements = {
						'labels': {}
					};

					// turn on debugger console
					if (options.debug) {
						my.utils.log("Debug mode on");

						$(document.body).append(
							my.elements.debug = $("<ul/>", {
								'id': 'storyboard-debug'
							}).css({
								'position': 'fixed',
								'left': 0,
								'top': 0,
								'zIndex': 10000,
								'backgroundColor': '#fff'
							}).append(
								$("<li/>").append(
									$("<span/>").text("Scrolled:")
								).append(
									my.elements.labels.scrolled = $("<span/>")
								)
							).append(
								$("<li/>").append(
									$("<span/>").text("VP:")
								).append(
									my.elements.labels.vp = $("<span/>")
								)
							).append(
								$("<li/>").append(
									$("<span/>").text("Active:")
								).append(
									my.elements.labels.active = $("<span/>")
								)
							)
						);
					}

					my.update(true);

					my.process_timeline();

					win.on("scroll", my.handle_event).on("resize", my.handle_event);

					my.status.active = true;

					my.utils.update_scroll(my.position);
				}
			},

			process_timeline: function() {
				// process timeline
				var block_id, tl, container, height, newnodes,
					get_style, node_process, key;

				get_style = function(element, property) {
					// process style property
					var value;

					value = element.css(property) || '0';
					return parseFloat(value.replace(my.regex.raw_number, ""));
				};

				node_process = function(node) {
					var element, prop;

					if ((element = container.find(node.selector).first())) {
						node.element = element;

						if (node.properties) {
							for (prop in node.properties) {
								if (node.properties.hasOwnProperty(prop)) {
									// compute origin styles
									if (typeof node.properties[prop][0] !== "number") {
										node.properties[prop][0] = get_style(
											element,
											prop
										);
									}

									if (node.properties[prop].length === 1 ||
										typeof node.properties[prop][1] !== "number") {
										node.properties[prop][1] = get_style(
											element,
											prop
										);
									}

									if (node.step &&
										(node.step > Math.abs(node.properties[prop][1] - node.properties[prop][0]))) {
										// keep step value within boundaries of potential values
										node.step = Math.abs(node.properties[prop][1] - node.properties[prop][0]);
									}
								}
							}
						} else {
							node = false;
							my.utils.log("Node reference to '" + node.selector + "' contains no valid" +
								" properties. Ignoring node.");
						}
					} else {
						node = false;
						my.utils.log("Node reference to '" + node.selector + "' could not be found." +
							" Ignoring node.");
					}

					if (node) {
						// set defaults
						if (typeof node.delay !== "number") {
							node.delay = (tl.delay !== undefined) ? tl.delay : 0;
						}

						if (typeof node.duration !== "number" || node.duration < 0 ||
							node.duration > height) {
							node.duration = (tl.duration !== undefined) ? tl.duration : height;
						}

						if (node.duration > height) {
							node.duration = height;
						}

						// add to storage
						newnodes.push(node);
					}
				};

				for (block_id in timeline) {
					if (timeline.hasOwnProperty(block_id)) {
						tl = timeline[block_id];
						container = $('#' + block_id);
						height = $(container).height();

						if (container &&
							(typeof tl.nodes === "object" && tl.nodes.length > 0)) {
							newnodes = [];

							for (key in tl.nodes) {
								if (tl.nodes.hasOwnProperty(key)) {
									node_process(tl.nodes[key]);
								}
							}

							tl.nodes = newnodes;
						} else {
							delete timeline[block_id];
						}
					}
				}
			},

			update: function(full) {
				// retrieve and update block data
				var blocks;

				if (full) {
					blocks = [];

					$(block_selector).each(function(index, element) {
						var layout, top, height;

						if (timeline[element.id]) {
							top = $(element).offset().top;
							height = $(element).height();

							blocks.push({
								'element': element,
								'height': height,
								'top': top,
								'bottom': (top + height)
							});
						}
					});

					my.blocks = blocks;

				}

				// update vp data
				my.status.vp = win.height();

				if (options.debug) {
					my.elements.labels.vp.text(my.status.vp);
				}
			},

			handle_event: function(event, element) {
				// centralised event handling method
				switch (event.type) {
					case 'scroll':
						my.utils.update_scroll(my.position);
						break;

					case 'resize':
						my.update();
						break;
				}
			},

			active_block_index: function() {
				// detect active block index based on scroll position
				var index, a;

				index = 0;

				for (a = 0; a < my.blocks.length; a += 1) {
					if (my.blocks[a].top <= (my.status.offset - options.offset)) {
						index = a;
					}
				}

				if (options.debug) {
					my.elements.labels.active.text(
						my.blocks[index].element.tagName +
							"#" + my.blocks[index].element.id +
							"." + my.blocks[index].element.className
					);
				}

				return index;
			},

			position: function() {
				var a, b, len, active, block, tl, node, prop, percent,
					start, end, value, step;

				len = my.blocks.length;
				active = my.active_block_index();

				for (a = 0; (block = my.blocks[a]); a += 1) {
					tl = timeline[block.element.id];

					if (block.stuck !== true) {
						for (b = 0; (node = tl.nodes[b]); b += 1) {
							// set start and end animation positions
							start = block.top + node.delay;

							end = start + node.duration;

							if (my.status.offset < start) {
								// scroll is before start of range
								percent = 0;
							} else if (my.status.offset > end) {
								// scroll is after end of range
								percent = 1;
							} else {
								// scroll is within range
								percent = (my.status.offset - start) / node.duration;

								// set tween function (from node or block timeline)
								/*if (node.tween) {
									percent = jQuery.easing[node.tween](percent);
								} else if (tl.tween) {
									percent = jQuery.easing[tl.tween](percent);
								}*/

								if (options.debug) {
									my.utils.log("Animating " + block.element.id + " (" + percent + "%)");
								}
							}

							for (prop in node.properties) {
								if (node.properties.hasOwnProperty(prop)) {
									// then multiply the percent by the value range and calculate the new value
									if (percent === 0) {
										my.utils.set_property(node.element, prop, node.properties[prop][0]);
									} else if (percent === 1) {
										my.utils.set_property(node.element, prop, node.properties[prop][1]);
									} else {
										if (node.step) {
											value = node.properties[prop][0] +
												Math.round(percent * (node.properties[prop][1] - node.properties[prop][0]) / node.step) *
												node.step;
										} else {
											value = (node.properties[prop][0] +
												(percent * (node.properties[prop][1] - node.properties[prop][0]))).toFixed(3);
										}

										my.utils.set_property(node.element, prop, value);
									}
								}
							}
						}

						if (tl.stick && (my.status.offset) >= block.bottom && percent === 1) {
							block.stuck = true;
							my.status.stuck += 1;

							if (my.status.stuck === my.blocks.length) {
								// disable events
								win.off("scroll").off("resize");

								my.utils.log("All blocks stuck - event bindings removed");
							}
						}
					}
				}
			},

			utils: {
				update_scroll: function(callback) {
					// updates the scroll numbers (on scroll)
					my.status.offset = window.scrollY || document.body.parentNode.scrollTop;
					my.status.offset_bottom = (my.status.offset + my.status.vp);

					if (options.debug) {
						my.elements.labels.scrolled.text(my.status.offset + " / " + my.status.offset_bottom);
					}

					if (callback !== undefined) {
						callback();
					}
				},

				set_property: function(element, prop, val) {
					switch (prop) {
						case 'opacity':
						case 'zoom':
							element.css(prop, val);
							break;

						case 'rotate':
							// transforms
							element.css("-webkit-transform", prop + "(" + val + "deg)");
							break;

						default:
							element.css(prop, val + "px");
					}
				},

				log: function(msg) {
					// log message to the console (if active)
					if (typeof console !== "undefined") {
						console.log(msg);
					}
				}
			}
		};

		my.enable();

		return cls;
	};

	if (typeof window.WS === "object") {
		window.WS.StoryBoard = WSStoryBoard;
	} else {
		window.WS = { 'StoryBoard': WSStoryBoard };
	}

	window.WSStoryBoard = WSStoryBoard;
}(window.jQuery, window.jQuery(window), window.ob_set));
